import i18n from '../i18n';

/**
 * Traduz partes do nome do produto mantendo coerência linguística
 * Exemplo: "Seca Barriga com Goji Berry + 30 Ervas" 
 * → Alemão: "Bauchfett Trocken mit Goji Beere + 30 Kräuter"
 */
export const translateProductName = (productName: string): string => {
  if (!productName) return productName;

  const terms = i18n.t('productTerms', { returnObjects: true }) as Record<string, string>;
  
  // Mapeamento de termos compostos que devem ser traduzidos juntos
  const compoundTerms: Record<string, string> = {
    'Seca Barriga': terms.seca && terms.barriga ? `${terms.barriga} ${terms.seca}` : 'Seca Barriga',
    'Goji Berry': terms.goji && terms.berry ? `${terms.goji} ${terms.berry}` : 'Goji Berry',
    'Queima Gordura': terms.queima && terms.gordura ? `${terms.queima} ${terms.gordura}` : 'Queima Gordura',
    'Fibra Digestiva': terms.fibra && terms.digestiva ? `${terms.digestiva} ${terms.fibra}` : 'Fibra Digestiva',
    'Pack Premium': terms.pack && terms.premium ? `${terms.premium} ${terms.pack}` : 'Pack Premium',
    'Pack Detox': terms.pack && terms.detox ? `${terms.detox} ${terms.pack}` : 'Pack Detox',
    'Pack Transformação': terms.pack && terms.transformacao ? `${terms.transformacao} ${terms.pack}` : 'Pack Transformação',
    'Drenagem Linfática': terms.drenagem && terms.linfatica ? `${terms.linfatica} ${terms.drenagem}` : 'Drenagem Linfática',
    'DRENAGEM LINFÁTICA': terms.drenagem && terms.linfatica ? `${terms.linfatica} ${terms.drenagem}`.toUpperCase() : 'DRENAGEM LINFÁTICA',
    'LYMPH DRAINAGE': terms.linfatica && terms.drenagem ? `${terms.linfatica} ${terms.drenagem}`.toUpperCase() : 'LYMPH DRAINAGE',
    'Detox Verde': terms.detox && terms.verde ? `${terms.detox} ${terms.verde}` : 'Detox Verde',
    'FANTÁSTICO EMAGRECEDOR': terms.fantástico && terms.emagrecedor ? `${terms.fantástico} ${terms.emagrecedor}`.toUpperCase() : 'FANTÁSTICO EMAGRECEDOR'
  };

  let translatedName = productName;

  // Primeiro, traduzir termos compostos
  Object.entries(compoundTerms).forEach(([original, translated]) => {
    if (translatedName.includes(original)) {
      translatedName = translatedName.replace(original, translated);
    }
  });

  // Depois, traduzir termos individuais que sobraram (ignorando case)
  Object.entries(terms).forEach(([key, value]) => {
    if (typeof value === 'string') {
      // Usar regex case-insensitive para substituir palavra
      const regex = new RegExp(key, 'gi');
      translatedName = translatedName.replace(regex, (match) => {
        // Preservar maiúsculas/minúsculas do original
        if (match === match.toUpperCase()) {
          return value.toUpperCase();
        } else if (match[0] === match[0].toUpperCase()) {
          return value.charAt(0).toUpperCase() + value.slice(1);
        }
        return value;
      });
    }
  });

  return translatedName;
};

/**
 * Hook para usar tradução de produtos em componentes React
 */
export const useProductTranslation = () => {
  return {
    translateName: translateProductName,
    translateDescription: translateProductName // Mesma função para descrições
  };
};

/**
 * Traduz descrição de produto
 */
export const translateProductDescription = (description: string): string => {
  return translateProductName(description);
};
